module.exports = __webpack_public_path__ + "static/media/edit-name.d6063460.svg";